import { SyncCollection } from "contentful";
import {
  IGetContentfulAction,
  GET_CONTENTFUL,
  IGetContentfulSuccessAction,
  GET_CONTENTFUL_SUCCESS,
  IGetContentfulErrorAction,
  GET_CONTENTFUL_ERROR,
  ISetCurrentLanguageAction,
  SET_CURRENT_LANGUAGE,
  ILanguageInfo,
  ISetSyncToken,
  SET_SYNC_TOKEN
} from "./types";
import { IJCoreEntry } from "./index";

export const getContentful = (): IGetContentfulAction => ({
  type: GET_CONTENTFUL
});

export const setCurrentLanguage = (lang: ILanguageInfo): ISetCurrentLanguageAction => ({
  type: SET_CURRENT_LANGUAGE,
  payload: lang
});

export const getContentfulSuccess = (contentful: {
  entries: IJCoreEntry<any>[];
  assets: IJCoreEntry<any>[];
}): IGetContentfulSuccessAction => ({
  type: GET_CONTENTFUL_SUCCESS,
  payload: contentful
});

export const getContentfulError = (): IGetContentfulErrorAction => ({
  type: GET_CONTENTFUL_ERROR
});

export const setSyncToken = (
  contentfulToken: SyncCollection["nextSyncToken"],
  dbTimestamp: number
): ISetSyncToken => ({
  type: SET_SYNC_TOKEN,
  payload: {
    contentfulToken,
    dbTimestamp
  }
});
